import React, { useEffect, useRef, useState, memo } from "react";
import Draggable from "react-draggable";

const DraggableWrapper = memo(function DraggableWrapper(props) {
  const handleStop = (e, ui) => {
    const { x, y } = ui;
    if(props.updateSlideElementPosition){
      props.updateSlideElementPosition(props.slideIndex, props.elementIndex, {
        x,
        y
      });
    }
  };

  const [hover, setHover] = useState(false);

  const handleMouseEnter = () => {
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  const [dimesions, ] = useState({
    width: props.element?.style?.width?.value,
    height: props.element?.style?.height?.value
  });

  const elementRef = useRef(null)

  useEffect(() => {
    const element = elementRef?.current;
    if (!element) return;
    const observer = new ResizeObserver(() => {
      const width = element.offsetWidth;
      const height = element.offsetHeight;
      if(width === 0 || height === 0) {
        return;
      }
      props.updateSlideElementSize && props.updateSlideElementSize(props.slideIndex, props.elementIndex, {
        width: `${width}px`,
        height: `${height}px`
      });
    });

    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.slideIndex, props.elementIndex, props.updateSlideElementSize]);

  return (
    <Draggable
      key={`${props.element?.key}-draggable-key-${props.elementIndex}-${props.slideIndex}-${props.element?.type}`}
      defaultPosition={{
        x: props.element?.position?.x || 0,
        y: props.element?.position?.y || 0
      }}
      onStop={handleStop}
      defaultClassName="hover:cursor-move absolute slide-element"
      handle=".handle"
      defaultClassNameDragging=""
      defaultClassNameDragged=""
    >
      <div
        ref={elementRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          resize: hover && !props.previewMode ? "both" : "none",
          overflow: "auto",
          width: dimesions.width,
          height: dimesions.height,
          border: hover && !props.previewMode ? "1px solid #ccc" : "none"
        }}
      >
        {props.children}
      </div>
    </Draggable>
  );
});

export default DraggableWrapper;